// tslint:disable

import { Field } from './form.lib';

export class ValidatorResponse {
    public message: string;
    public isValid: boolean;

    constructor(message: string, isValid: boolean) {
        this.message = message;
        this.isValid = isValid;
    }
}

export class RegEx {
    public static website = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    public static email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    public static phoneNumber = /^[\s\d\/\)\(\+]+$/;

    public static isEmail(value: string): boolean {
        return RegEx.email.test(value);
    }

    public static isWebsite(value: string): boolean {
        return RegEx.website.test(value);
    }

    public static isPhoneNumber(value: string): boolean {
        return RegEx.phoneNumber.test(value);
    }

}

export type Validator = (field: Field) => Promise<ValidatorResponse>;

export class Validators {

    public static whatDoYouWant(message: string, valid: boolean): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => Promise.resolve(new ValidatorResponse(message, valid));
    }

    public static required(message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {
            if (typeof field.value === 'string' && !field.value) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            if (field.value === undefined || field.value === null) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            if (Array.isArray(field.value) && field.value.length < 1) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            resolve(new ValidatorResponse(message, true));
        });
    }

    public static maxLength(maxNum: number, message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {

            if (typeof field.value === 'string' && field.value && field.value.length > maxNum) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            if (Array.isArray(field.value) && field.value.length > maxNum) {
                resolve(new ValidatorResponse(message, false));
                return;
            }
            resolve(new ValidatorResponse(message, true));
        })
    }

    public static range(minNum: number, maxNum: number, message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {

            if (typeof field.value === 'string' && field.value && (field.value.length > maxNum || field.value.length < minNum)) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            if (Array.isArray(field.value) && (field.value.length > maxNum || field.value.length < minNum)) {
                resolve(new ValidatorResponse(message, false));
            }
            resolve(new ValidatorResponse(message, true));
        })
    }

    public static isEmail(message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {
            if (typeof field.value === 'string' && !field.value) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            if (typeof field.value === 'string' && field.value && !RegEx.isEmail(field.value)) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            resolve(new ValidatorResponse(message, true));
        })
    }

    public static isWebsite(message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {
            if (typeof field.value === 'string' && !field.value) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            if (typeof field.value === 'string' && field.value && !RegEx.isWebsite(field.value)) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            resolve(new ValidatorResponse(message, true));
        })
    }

    public static isPhoneNumber(message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {
            if (typeof field.value === 'string' && !field.value) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            if (typeof field.value === 'string' && field.value && !RegEx.isPhoneNumber(field.value)) {
                resolve(new ValidatorResponse(message, false));
                return;
            }

            resolve(new ValidatorResponse(message, true));
        })
    }

    public static isHammerTime(message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {
            setTimeout(() => {
                if (field.value !== 'hammertime') {
                    resolve(new ValidatorResponse(message, false));
                    return;
                }
                resolve(new ValidatorResponse(message, true));
            }, 2000);
        });
    }

    public static wysiwygRequired(message: string): (field: Field) => Promise<ValidatorResponse> {
        return (field: Field) => new Promise((resolve, reject) => {
            if (!field.value || field.value === '<p><br></p>') {
                resolve(new ValidatorResponse(message, false));
                return;
            }
            resolve(new ValidatorResponse(message, true));
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/Validators.ts